//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import TabelaGenerica from '../../../../shared-components/generico/TabelaGenerica';
import { generateComputed } from '../../../../common/functions/roles-computed-generator';


export default {
  extends: TabelaGenerica,
  computed: {
    ...generateComputed('Tipo Acao', [
      'canAccessCRUD',
    ]),
  },
  watch: {
    paginationSize(valor) {
      this.$emit('PAGINACAO_ALTERANDO_TAMANHO_PAGINA', valor);
    },
  },
  data() {
    return {
      tipos: [
        { tipo: 'FIXO', descricao: this.$t('label.gasto_fixo') },
        { tipo: 'MARGEM', descricao: this.$t('label.margem') },
      ],
    };
  },
};



// WEBPACK FOOTER //
// ./src/custom/abbrasil/spa/tipo-acao/TipoAcaoTabela.vue?vue&type=script&lang=js&